export default __webpack_public_path__ + "static/media/scoreboard_thumb.00dd90b3.jpeg";